import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRacketComponent } from './simple-icons-racket.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRacketComponent ],
    exports:      [ SimpleIconsRacketComponent ],
    bootstrap:    []
})
export class SimpleIconsRacketModule {}
